/** Daily locker cash prize (AUD) — single source for marketing copy across platforms. */
export const DAILY_CASH_PRIZE_AMOUNT_AUD = 1000;

export const DAILY_CASH_PRIZE_AUD_DISPLAY_LABEL =
  DAILY_CASH_PRIZE_AMOUNT_AUD.toLocaleString("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  });
